import CHARITH_PICTURE from "./headshots/Communications/Charith Kongara - Newsletter Editor.jpg";
import KAMI_PICTURE from "./headshots/Communications/Kami Duong - Comic Designer.jpg";
import KEVIN_PICTURE from "./headshots/Communications/Kevin Khuu - Communications Associate.jpg";

import AHMAD_PICTURE from "./headshots/Development/Ahmad Beirkdar - Developer.jpg";
import DAN_PICTURE from "./headshots/Development/Dan Stingaciu - Development Advisor.jpg";
import ERIO_PICTURE from "./headshots/Development/Erio Hoti - Developer.jpg";
import NATHANIEL_PICUTRE from "./headshots/Development/Nathaniel Fernandes - Developer.jpg";
import RICHARD_PICTURE from "./headshots/Development/Richard Marquez - Developer.jpg";
import VANESSA_PICTURE from "./headshots/Development/Vanessa Hoang - UX_UI Developer.jpg";

import DENIZ_PICTURE from "./headshots/Operations/Deniz Saygili - Director of Finance.jpg";
import MARJAN_PICTURE from "./headshots/Operations/Marjan Ahmed - Operations Associate.jpg";
import SERENA_PICTURE from "./headshots/Operations/Serena Correa - Operations Associate.jpg";

import EGG_PICTURe from "./headshots/eggw.png";
const headshots = [
  {
    name: "Charith Kongara",
    role: "Newsletter Editor",
    image: CHARITH_PICTURE,
  },
  { name: "Kami Duong", role: "Comic Designer", image: KAMI_PICTURE },
  {
    name: "Kevin Khuu",
    role: "Communications Associate",
    image: KEVIN_PICTURE,
  },
  { name: "Ahmad Beirkdar", role: "Developer", image: AHMAD_PICTURE },
  { name: "Dan Stingaciu", role: "Development Advisor", image: DAN_PICTURE },
  { name: "Erio Hoti", role: "Developer", image: ERIO_PICTURE },
  { name: "Nathaniel Fernandes", role: "Developer", image: NATHANIEL_PICUTRE },
  { name: "Richard Marquez", role: "Developer", image: RICHARD_PICTURE },
  { name: "Vanessa Hoang", role: "UX/UI Developer", image: VANESSA_PICTURE },
  { name: "Deniz Saygili", role: "Director of Finance", image: DENIZ_PICTURE },
  { name: "Marjan Ahmed", role: "Operations Associate", image: MARJAN_PICTURE },
  {
    name: "Serena Correa",
    role: "Operations Associate",
    image: SERENA_PICTURE,
  },
  { name: "Eggward", role: "Ambassador", image: EGG_PICTURe },
];
export default headshots;
